import provider from '@/helpers/provider';
import { multicall } from '@/helpers/utils';
import abi from '../../abi';

export async function getFinalFixPrices(
  marketContract: any,
  nftContract: any,
  nftIds: any
) {
  if (!marketContract || !nftContract) {
    return [];
  }
  const calls = nftIds.map((nftId: any) => ({
    address: marketContract,
    name: 'getFinalPrice',
    params: [nftContract, nftId]
  }));
  const res = await multicall(provider, abi['Marketplace'], calls);
  if (!res) {
    return [];
  }
  return res.map((item: any, index: any) => {
    const [price, currency] = item;
    return {
      nftId: nftIds[index],
      price: price.toString(),
      currency
    };
  });
}

export async function getFinalDutchAuctionPrices(
  marketContract: any,
  nftContract: any,
  nftIds: any
) {
  if (!marketContract || !nftContract) {
    return [];
  }
  const calls = nftIds.map((nftId: any) => ({
    address: marketContract,
    name: 'getDutchAuctionFinalPrice',
    params: [nftContract, nftId]
  }));
  const res = await multicall(
    provider,
    abi['BunicornNFTAuctionMarketplace'],
    calls
  );
  if (!res) {
    return [];
  }
  return res.map((item: any, index: any) => {
    const [price, currency] = item;
    return {
      nftId: nftIds[index],
      price: price.toString(),
      currency
    };
  });
}
